import { render, staticRenderFns } from "./trusted-device-mobile.vue?vue&type=template&id=81af9004&scoped=true&"
import script from "./trusted-device-mobile.vue?vue&type=script&lang=js&"
export * from "./trusted-device-mobile.vue?vue&type=script&lang=js&"
import style0 from "./trusted-device-mobile.vue?vue&type=style&index=0&id=81af9004&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81af9004",
  null
  
)

export default component.exports